import { render, staticRenderFns } from "./ButtonReport.vue?vue&type=template&id=18d42f14"
import script from "./ButtonReport.vue?vue&type=script&lang=js"
export * from "./ButtonReport.vue?vue&type=script&lang=js"
import style0 from "./ButtonReport.vue?vue&type=style&index=0&id=18d42f14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports